import { render, staticRenderFns } from "./BillInfo.vue?vue&type=template&id=38dd0bd3&scoped=true"
import script from "./BillInfo.vue?vue&type=script&lang=js"
export * from "./BillInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd0bd3",
  null
  
)

export default component.exports